import { PathOptions } from "leaflet";

export const pch_base_existente = (feature: any): PathOptions => {
  return {
    color: "#2E8B57",
    weight: 2,
    opacity: 1,
    fillColor: "#3CB371",
    fillOpacity: 0.6,
  };
};
